import { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { Box } from "@mui/material";
import SidebarComponent from "./Sidebar";
import ChecklistForm from "./FormComponent";
import setupAtoms, { getChecklist, getcpChecklist } from "../../../atoms/setup/SetupAtoms";
import settingsAtom from "../../../atoms/settings/SettingsAtom";
import dashboardAtoms, { fetchPartsAtom } from "../../../atoms/Dashboard/DashboardAtom";
import NotesComponent from "./NotesComponent"

const ConstructionProgress = () => {
  const [data] = useAtom(setupAtoms);
  const [, setcpChecklist] = useAtom(getcpChecklist);
  const [loader, setLoader] = useState(false);
  const [settingData] = useAtom(settingsAtom);
  const [dashboardData] = useAtom(dashboardAtoms)
  const { projectList } = settingData;
  const { partList } = dashboardData;
  const currentProject = projectList.find(o => o.id === parseInt(localStorage.getItem("project_id")));
  const [, setPart] = useAtom(fetchPartsAtom);
  const [, setCheckLists] = useAtom(getChecklist);
  const { checklistValue, cpChecklist  } = data;
  const [active, setActive] = useState("checklist")
  const [isEdit, setIsEdit] = useState(false);


  const initialFetch = async () => {
    setLoader(true);
    try {
      await setcpChecklist("");
      await setCheckLists("Construction")
      await setPart()
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    initialFetch();
    // eslint-disable-next-line
  }, []);

  return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <Box sx={{ height: 'calc(100vh - 116px)', width: '24%', borderRight: '1px solid #e0e0e0' }}>    
                <SidebarComponent
                    data={cpChecklist}
                    loader={loader}
                    title={"CP Checklist"}
                    setActive={setActive}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                />
            </Box>
            <Box
                sx={{
                    height: 'calc(100vh - 116px)',
                    width: '76%',
                }}
            >
              {active === "checklist" ?
                 <ChecklistForm 
                    loader={loader}
                    currentProject={currentProject}
                    data={partList} 
                    value = {checklistValue}
                /> :
                <NotesComponent 
                  loader={loader}
                  active={active}
                  currentProject={currentProject}
                  checkList={partList} 
                  value = {checklistValue}
                  data = {checklistValue?.data}
                />
                }
            </Box>
        </Box>
  );
};

export default ConstructionProgress;
